import React, { useContext, useState } from "react";

import { AssignmentInd } from "@material-ui/icons";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip } from "@mui/material";

import ReactMustache from 'react-mustache';
import { Formik } from "formik";
import * as Yup from 'yup';
import { BrandContext } from "../../../contexts/BrandContext";
import { ProfileContext } from "../../../contexts/ProfileContext";
import { formatDate, formatTime } from "../../../contexts/BookingUtilities";
import { cLog, cWarn } from "../CustomLogger";
import BasicInputField from "../form/BasicInputField";
import axios from "../../../utils/axios";


export default function ParentApprovalIcon(props){

    let parentClass = 'unapproved';
    const {booking,updateCall} =  props;
    const {profile } = useContext(ProfileContext);
    const brandContext = useContext(BrandContext);

    const {
        textContent:{
            approveOnBehalfOfParentTitle='',
            awaitingApprovalFromParent='',
            parentApprovedByTitle='',
        }
    } = brandContext;


    let hasApprovalRight = false;
    const {
        staffUserData=false,
        hasSuperRights=false
    } = profile;

    if(staffUserData){
        ({hasApprovalRight}=staffUserData);
    }
    if(hasSuperRights){
        hasApprovalRight = true;
    }
    

    const [showApprovalDialogue,setShowApproveDialogue] = useState(false);
    if(booking) {

        const{
            housemApprovedDate:housemApproval,
            parentApprovedDate:parentApproval,
            parentContact={},
            id,
            isCancelled,
            authorisedIp=null
        } =  booking;
        
        let approveProps = {};
        if(hasApprovalRight && !parentApproval && !isCancelled){
            approveProps = {
                onClick:()=>{
                    setShowApproveDialogue(true);
                },
                sx:{
                    cursor:'pointer'
                }
            };
        }
        let contactFullName = '';
        if(parentContact){
            const {
                firstName:contactFirstName='',
                lastName:contactLastName=''
            } = parentContact;
            contactFullName = `${contactFirstName} ${contactLastName}`.trim();
        }  

        

        let parentTip = <ReactMustache Component="span" template={awaitingApprovalFromParent} data={{contactName:contactFullName}}/>
        if (parentApproval) {
            parentClass = 'partApproved';

            const data = {
                contactName:contactFullName,
                dateApproved:`${formatDate(parentApproval)} at ${formatTime(parentApproval)}`,
                ip:authorisedIp
            }

            parentTip = <ReactMustache Component="span" template={parentApprovedByTitle} data={data}/>;
        }
        else if(hasApprovalRight && !isCancelled){
            const data = {
                contactName:contactFullName,
                ip:authorisedIp
            }
            parentTip = <ReactMustache Component="span" template={approveOnBehalfOfParentTitle} data={data}/>;
        }
        if (housemApproval && parentApproval) {
            parentClass = 'fullyApproved';
        }
        return (
            <>
                <Tooltip title={parentTip}>
                    <IconButton 
                        size="small" 
                        className={parentClass} 
                        {...approveProps}
                    >
                        <AssignmentInd/>
                    </IconButton>
                </Tooltip>

                {
                    showApprovalDialogue &&
                    <ApproveDialogue
                        title={parentTip}
                        showDialogue={showApprovalDialogue}
                        setShowDialogue={setShowApproveDialogue}
                        bookingId={id}
                        updateCall={updateCall}
                    />
                }

            </>
        );
    }
    return <></>;
}

const ApproveDialogue = (props) => {

    const {
        title='',
        showDialogue,
        setShowDialogue,
        bookingId,
        updateCall
    } = props;
    
    const brandContext = useContext(BrandContext);
    const {
        textContent:{
            approveButtonText=''
        }
    } = brandContext;
    
    const validationSchema = Yup.object().shape({
        notes: Yup.string()
            .required('Required'),
    });

    const formFields = {
        'notes': {
            'label': 'approveOnBehalfFormLabel',
            'type':'textarea',
            'default':''
        },
    }

    const initialValues = () => {
        const fields = formFields;

        const initialValues = {};
        const keys = Object.keys(fields);
        const values = Object.values(fields);
        for (let i = 0; i < keys.length; i += 1) {
            initialValues[keys[i]] = ('default' in values[i] ? values[i].default : '');
        }
        return initialValues;
    }
    
    
    return (<Dialog open={showDialogue} onClose={()=>{setShowDialogue(false)}}>
        <DialogTitle>{title}</DialogTitle>
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                cLog(values);
                const apiPath = `${process.env.REACT_APP_API_URL}/approveonbehalfof/${bookingId}`;
                axios.post(apiPath,values,{
                    timeout: 300000,
                    withCredentials:true
                }).then(() => {
                    setShowDialogue(false);
                    if(updateCall){
                        updateCall(bookingId,{parentApprovedDate:new Date()});
                    }
                }).catch(err => {
                   // console.log('caught the error');
                   cWarn(err);
                });
            }}
        >
            {props => (
                <form onSubmit={props.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <BasicInputField sx={{width:400}}  formik={props} formFields={formFields} fieldName="notes" variant='outlined'/>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>{setShowDialogue(false)}}>Cancel</Button>
                        <Button type="submit">{approveButtonText}</Button>
                    </DialogActions>
                </form>                                
            )}
        </Formik>
    </Dialog>);
}